import api from '../utils/api';

const BASE = '/api/followers';

/**
 * Check whether the logged-in user follows another user.
 * @route GET /api/followers/:followingId/status
 * @param {string} followingId
 * @returns {Promise<{isFollowing: boolean}>}
 */
export const getFollowStatus = (followingId) =>
    api.get(`${BASE}/${followingId}/status`).then((r) => r.data);

/**
 * Follow another user.
 * @route POST /api/followers/:followingId
 * @param {string} followingId
 * @returns {Promise<Object>}
 */
export const followUser = (followingId) =>
    api.post(`${BASE}/${followingId}`).then((r) => r.data);

/**
 * Unfollow another user.
 * @route DELETE /api/followers/:followingId
 * @param {string} followingId
 * @returns {Promise<Object>}
 */
export const unfollowUser = (followingId) =>
    api.delete(`${BASE}/${followingId}`).then((r) => r.data);

/**
 * Get one page of users the given profile owner follows.
 * @route GET /api/followers/following/:profileCreatorId
 * @param {string} profileCreatorId - The user whose following list is being viewed.
 * @param {number} [page=1]
 * @param {number} [limit=20]
 * @returns {Promise<{results: Object[], page: number, limit: number, total: number, hasMore: boolean}>}
 */
export const getFollowing = (profileCreatorId, page = 1, limit = 20) =>
    api.get(`${BASE}/following/${profileCreatorId}`, { params: { page, limit } }).then((r) => r.data);

/**
 * Get one page of the given profile owner's followers.
 * @route GET /api/followers/followers/:profileCreatorId
 * @param {string} profileCreatorId - The user whose follower list is being viewed.
 * @param {number} [page=1]
 * @param {number} [limit=20]
 * @returns {Promise<{results: Object[], page: number, limit: number, total: number, hasMore: boolean}>}
 */
export const getFollowers = (profileCreatorId, page = 1, limit = 20) =>
    api.get(`${BASE}/followers/${profileCreatorId}`, { params: { page, limit } }).then((r) => r.data);

/**
 * Get the visibility setting for a user's follower/following lists.
 * @route GET /api/followers/visibility/:profileCreatorId
 * @param {string} profileCreatorId - The user whose visibility setting is being checked.
 * @returns {Promise<{isVisible: boolean}>}
 */
export const getFollowVisibility = (profileCreatorId) =>
    api.get(`${BASE}/visibility/${profileCreatorId}`).then((r) => r.data);

/**
 * Updating the setting for making following/follower list public or private
 * @route PUT /api/followers/visibility
 * @param {boolean} isVisible - Whether the follower/following list should be public.
 * @returns {Promise<Object[]>}
 */
export const updateFollowVisibility = (isVisible) =>
    api.put(`${BASE}/visibility`, {isVisible}).then((r) => r.data);